import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ImageUpload from '../../../../../../../components/global/ImageUpload';
import CustomControl from '../../../../../../../components/global/CustomControl';
import useAssetImageUpoad from '../../../../../../../hooks/useAssetImageUpload';

const propTypes = {
  className: PropTypes.string,
  elementConfiguration: PropTypes.shape({
    element: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    configuration: PropTypes.shape({
      border: PropTypes.shape({
        type: PropTypes.string,
        width: PropTypes.number,
        color: PropTypes.string,
        opacity: PropTypes.number,
      }),
      photo_element_configuration: PropTypes.shape({
        asset_image_id: PropTypes.string,
        existing_asset_image_id: PropTypes.number,
        cropbox: PropTypes.shape({
          x: PropTypes.number.isRequired,
          y: PropTypes.number.isRequired,
          scale: PropTypes.number.isRequired,
          rotation: PropTypes.number.isRequired,
        }),
      }),
    }).isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

const CardPhotoElementConfiguration = ({
  className,
  elementConfiguration,
  onChange,
}) => {
  const classes = classNames({
    'card-element-configuration': true,
    'card-photo-element-configuration': true,
    [className]: !!className,
  });

  const { uploading, onUpload, onUploadReset, image } = useAssetImageUpoad({
    onImageUploaded: assetImage => {
      onChange({
        photo_element_configuration: {
          asset_image_id: assetImage.id,
          existing_asset_image_id: null,
          cropbox: null,
        },
      });
    },
  });

  const { element, configuration } = elementConfiguration;

  return (
    <div className={classes}>
      <h3 className="card-element-configuration-type">{element.type}</h3>

      {!configuration.is_editabe && (
        <ImageUpload
          id={`${element.id}-${element.card_template_id}-image-upload`}
          loading={uploading}
          onImageDismiss={() => {
            onUploadReset();
            onChange({
              photo_element_configuration: {
                asset_image_id: null,
                existing_asset_image_id: null,
                cropbox: null,
              },
            });
          }}
          onInputChange={event => {
            const [file] = event.target.files;
            onUpload(file);
          }}
          image={
            configuration?.photo_element_configuration?.asset_image_id && image
          }
          className="mb-2"
        />
      )}

      <CustomControl
        id={`${element.id}-${element.card_template_id}-editable`}
        type="checkbox"
        label="Read Only (non editable)"
        value={!configuration.is_editabe}
        onChange={event => {
          onChange({ is_editable: !event.target.checked });
        }}
      />

      <pre className="card-element-configuration-metadata">
        <p>z-index: {element.z_index}</p>
      </pre>
    </div>
  );
};

CardPhotoElementConfiguration.propTypes = propTypes;

export default CardPhotoElementConfiguration;
